<template>
  <section class="step2">
    <div class="step2-inner">
      <div class="step2-titleWrap">
        <div class="sub-title">STEP.02</div>
        <h2 class="title">比較する商品を選ぶ</h2>
      </div>
      <div class="category">
        <div class="category-head">
          <label class="checkbox">
            <input
              class="checkbox-input"
              type="checkbox"
              name="step2"
              :checked="isAllChecked"
              @click="handleAllCheckClicked"
            />
            <div class="checkbox-title">すべて選択</div>
          </label>
          <p class="category-note">
            検索結果 : {{ items.length }}件中{{ selectedNum }}件選択
          </p>
        </div>
        <ul class="list">
          <li class="list-item" v-for="item in items" :key="item.jan_code">
            <ItemCheckbox :data="item" />
          </li>
        </ul>
        <p class="note">
          ※各商品カテゴリーの人気上位10位内の商品には価格の右側に順位を表示しています。
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import ItemCheckbox from "./ItemCheckbox.vue";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "step2",
  components: {
    ItemCheckbox,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters("product", ["selectedProductIds"]),
    ...mapGetters("jsonData", ["tables"]),
    selectedNum() {
      return this.selectedProductIds.length;
    },
    isAllChecked() {
      return this.items.length === this.selectedNum && this.items.length !== 0;
    },
  },
  methods: {
    analyze(eventId) {
      adobeClickEvent(`step2_${eventId}`);
    },
    handleAllCheckClicked() {
      this.analyze("all");
      if (this.isAllChecked) {
        this.checkOutAllBox();
      } else {
        this.checkAllBox();
      }
    },
    checkAllBox() {
      const allIds = this.items.map((item) => item.jan_code);
      this.$store.dispatch("product/setSelectedProductIds", {
        value: allIds,
      });
    },
    checkOutAllBox() {
      this.$store.dispatch("product/setSelectedProductIds", {
        value: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.step2 {
  margin-top: 12px;
  width: 100%;
  position: relative;

  .step2-inner {
    width: 100%;
    max-width: 960+20 * 2px;
    padding: 0 20px;
    margin: 0 auto;
  }

  .step2-titleWrap {
    text-align: center;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 2.4px;
  }

  .sub-title {
    font-family: Oswald;
    color: $main-red;
    font-size: 16px;
    letter-spacing: 1.2px;
  }

  .category {
    width: 100%;
    margin-top: 20px;
  }

  .category-head {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0px 0px;

    & > .checkbox {
      width: auto;
      margin-right: 12px;
    }
  }

  .category-title {
    text-align: left;
  }

  .category-note {
    line-height: 1.2;
  }

  .list {
    width: 100%;
    margin-top: 15px;
    border-top: 1px solid #ddd;
  }

  .list-item {
    width: 100%;
    border-top: 1px solid #ddd;

    &:first-child {
      border-top: none;
    }
    &:last-child {
      border-bottom: 1px solid #ddd;
    }
  }

  .note {
    text-align: left;
    font-size: 12px;
    margin-top: 15px;
    padding: 0 0;
    text-align: left;
  }

  @include media() {
    margin: 0;

    .step2-inner {
      max-width: none;
    }

    .title {
      font-size: vw(16);
      letter-spacing: vw(1.4);
    }

    .sub-title {
      font-size: vw(14);
      letter-spacing: vw(1.2);
    }

    .category {
      margin-top: vw(30);
    }

    .category-head {
      padding: 0px vw(1);

      & > .checkbox {
        margin-right: vw(12);
      }
    }
    .category-left {
      display: block;
    }
    .category-note {
      font-size: vw(11);
      margin: 0;
    }

    .list {
      margin-top: vw(11);
    }

    .note {
      font-size: 10px;
      line-height: 1.4;
    }
  }
}
</style>
